"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPostInterface = exports.UserGetInterface = exports.UserData = exports.UserRole = void 0;
const t = __importStar(require("io-ts"));
const NonEmptyString_1 = require("../NonEmptyString");
const EMailString_1 = require("../EMailString");
exports.UserRole = t.union([t.literal('admin'), t.literal('moderator')]);
exports.UserData = t.type({
    name: NonEmptyString_1.NonEmptyString,
    email: t.union([EMailString_1.EMailString, t.undefined, t.null]),
    password: NonEmptyString_1.NonEmptyString,
    role: exports.UserRole,
});
// FIXME: Make get interfaces strict, so we are not leaking any data
exports.UserGetInterface = t.type({
    name: NonEmptyString_1.NonEmptyString,
    email: t.union([EMailString_1.EMailString, t.undefined, t.null]),
    role: exports.UserRole,
});
exports.UserPostInterface = t.type({
    name: NonEmptyString_1.NonEmptyString,
    password: NonEmptyString_1.NonEmptyString,
});
//# sourceMappingURL=User.js.map